(function() {
    'use strict';

    function MultipleUserAccountsError(message, userOptions) {
        if(angular.isArray(message)) {
            userOptions = message;
            message = null;
        }

        this.name = 'MultipleUserAccountsError';
        this.message = message || 'Cannot login due to multiple user accounts';
        this.userOptions = userOptions;
    }

    MultipleUserAccountsError.prototype = new Error();
    MultipleUserAccountsError.prototype.constructor = MultipleUserAccountsError;

    angular.module('app').constant('MultipleUserAccountsError', MultipleUserAccountsError);
})();